import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import { GdsCommonUtilityService } from '@upr-web-primer/gds-common-utility';
import { get } from 'lodash-es';

class GdsImageLinkModelModule {
}
GdsImageLinkModelModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsImageLinkModelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
GdsImageLinkModelModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsImageLinkModelModule });
GdsImageLinkModelModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsImageLinkModelModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsImageLinkModelModule, decorators: [{
            type: NgModule,
            args: [{}]
        }] });

class GdsImageLinkModelService {
    constructor(injector) {
        this.injector = injector;
    }
    get utilities() {
        if (!this._utilities) {
            this._utilities = this.injector.get(GdsCommonUtilityService);
        }
        return this._utilities;
    }
    init(field, isXpath) {
        const embeddedValues = get(field, 'EmbeddedValues', []);
        const imageButtonArray = [];
        if (['iconImage', 'landLogo'].includes(field.Name)) {
            const iconImage = this.utilities.getImageUrl(field, 'Multimedia', isXpath);
            return iconImage;
        }
        else {
            for (let i = 0; i <= embeddedValues.length - 1; i++) {
                imageButtonArray.push({
                    image: this.utilities.getImageUrl(field, 'image', true, i, isXpath),
                    title: isXpath
                        ? get(field, `EmbeddedValues[${i}].title.XPath`)
                        : get(field, `EmbeddedValues[${i}].title.Values[0]`),
                    href: this.utilities.getHref(embeddedValues[i]),
                    analytics: get(field, `EmbeddedValues[${i}].analytics.Values[0]`),
                    target: get(field, `EmbeddedValues[${i}].target.KeywordValues[0].Key`),
                    ariaLabel: get(field, `EmbeddedValues[${i}].ariaLabel.Values[0]`),
                    style: get(field, `EmbeddedValues[${i}].style.KeywordValues[0].Key`, ''),
                });
            }
            return imageButtonArray;
        }
    }
}
GdsImageLinkModelService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsImageLinkModelService, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
GdsImageLinkModelService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsImageLinkModelService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsImageLinkModelService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; } });

export { GdsImageLinkModelModule, GdsImageLinkModelService };
